import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

/** The amber note the Shopify connection card uses for warnings and save errors. */
export function AmberNote({ children, role }: { children: ReactNode; role?: 'alert' | 'status' }) {
  return (
    <div className="flex gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-amber-950" role={role}>
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <p className="text-xs">{children}</p>
    </div>
  );
}
